module.exports = new __parcel__URL__("exploring_nasa_aq_gis.0b672acd.png").toString();